import angular from 'angular';
import { tnCookieBannerDirective } from './cookieBanner.directive/cookieBanner';
import { ErrorController } from './error.view/tnError';
import { ExpandoExplicit } from './expando.directive/tnExpando';
import { ExpandoToggle } from './expando.directive/tnExpandoToggle';
import { HelpPopover } from './helpPopover.directive/helpPopover';
import { MainHeader } from './main-header.directive/mainHeader';
import { navBarComponent } from './nav-bar.view/navBar';
import { PluralizeDirective } from './ng-pluralize-html';
import emailPopoverTemplate from './partials/email-popover.html';
import emailSentTemplate from './partials/email-sent.html';
import { SelectSubset } from './select-subset.directive/selectSubset';
import { SelectController, SelectDirective } from './select.directive/select';
import {
    ShareUrlController,
    shareUrlComponent,
} from './share-url.view/shareUrl';
import { sidebarToggleComponent } from './sidebar-toggle.directive/tnSidebarToggle';
import { SizeSlider } from './size-slider.directive/sizeSlider';
import { Spaceless } from './spaceless.directive/spaceless';
import subsetPopoverTemplate from './subset-popover.view/subset-popover.html';
import { SubsetPopover } from './subset-popover.view/subsetPopover';
import { tnCurrentDatetime } from './tn-current-date-time.directive/tnCurrentDateTime';
import { tnDateSelect } from './tn-date-select.directive/tnDateSelect';
import { tnNoauto } from './tn-input-noauto.directive/tnInputNoauto';
import { TypeaheadController } from './typeahead.controller';
import { typeaheadStayOpen } from './typeaheadStayOpen.directive/typeaheadStayOpen';
import { TnViewToolbarComponent } from './tn-view-toolbar.directive/tnViewToolbar2';
import { EmailPopoverFormComponent } from './email-popover-form/email-popover-form';
import { EmailPopoverConfirmationComponent } from './email-popover-confirmation/email-popover-confimation';

function populateTemplateCache($templateCache) {
    // inject into template cache for reuse.
    $templateCache.put(
        'tn.ui/partials/email-popover.html',
        emailPopoverTemplate
    );
    $templateCache.put('tn.ui/partials/email-sent.html', emailSentTemplate);
    $templateCache.put(
        'tn.ui/subset-popover.view/subset-popover.html',
        subsetPopoverTemplate
    );
}
populateTemplateCache.$inject = ['$templateCache'];

export function titleCase(input = ''): string {
    return input.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
}
export default angular
    .module('tn.ui', [
        'ui.router',
        'tn.popover',
        'ngSanitize',
        'tn.user',
        'tn.fonts',
        'tn.utils',
    ])
    // components
    .component('emailPopoverForm', EmailPopoverFormComponent)
    .component('emailPopoverConfirmation', EmailPopoverConfirmationComponent)
    .component('tnNavBar', navBarComponent)
    .component('tnSidebarToggle', sidebarToggleComponent)
    .component('tnViewToolbar2', TnViewToolbarComponent)
    .component('tnShareUrl', shareUrlComponent)
    .controller('tnError', ErrorController)
    .controller('tnSelectController', SelectController)
    .controller('tnShareUrlController', ShareUrlController)
    .controller('tnSubsetPopover', SubsetPopover)
    .controller('tnTypeaheadController', TypeaheadController)
    .directive('ngPluralizeHtml', PluralizeDirective)
    .directive('tnCookieBanner', tnCookieBannerDirective)
    .directive('tnCurrentDatetime', tnCurrentDatetime)
    .directive('tnDateSelect', tnDateSelect)
    .directive('tnExpandoExplicit', ExpandoExplicit)
    .directive('tnExpandoToggle', ExpandoToggle)
    .directive('tnHelpPopover', HelpPopover)
    .directive('tnMainHeader', MainHeader)
    .directive('tnSelect', SelectDirective)
    .directive('tnSelectSubset', SelectSubset)
    .directive('tnSizeSlider', SizeSlider)
    .directive('tnSpaceless', Spaceless)
    .directive('tnNoauto', tnNoauto)
    .directive('typeaheadStayOpen', typeaheadStayOpen)
    // providers
    .filter('stripQuotes', () => (input) => (input || '').replace(/['"]/g, ''))
    .filter('titleCase', () => titleCase)
    // bootstrap
    .run(populateTemplateCache).name;
